import { z } from 'zod';

import {
  MaterialCaptureTypeSchema,
  MaterialPresentationTypeSchema,
} from '../materials-catalog/materials-catalog.schema.js';
import type {
  GetStationPurchaseQuickViewsRequest,
  GetStationPurchaseQuickViewsResponse,
  PurchaseQuickViewCriteria,
  PurchaseQuickViewCrvEligibility,
  PurchaseStationQuickView,
  PurchaseStationQuickViewInput,
  ReplaceStationPurchaseQuickViewsRequest,
  ReplaceStationPurchaseQuickViewsResponse,
} from './purchases-quick-views.dto.js';

export const PurchaseQuickViewCrvEligibilitySchema: z.ZodType<PurchaseQuickViewCrvEligibility> =
  z.enum(['any', 'crv', 'scrap']);

export const PurchaseQuickViewCriteriaSchema: z.ZodType<PurchaseQuickViewCriteria> = z.object({
  presentationTypes: z.array(MaterialPresentationTypeSchema),
  captureTypes: z.array(MaterialCaptureTypeSchema),
  crvEligibility: PurchaseQuickViewCrvEligibilitySchema,
});

export const PurchaseStationQuickViewSchema: z.ZodType<PurchaseStationQuickView> = z.object({
  id: z.string().min(1),
  code: z.string().min(1),
  label: z.string().min(1),
  enabled: z.boolean(),
  isProtected: z.boolean(),
  criteria: PurchaseQuickViewCriteriaSchema,
  sortOrder: z.number().int().nonnegative(),
});

export const PurchaseStationQuickViewInputSchema: z.ZodType<PurchaseStationQuickViewInput> =
  z.object({
    id: z.string().min(1).optional(),
    code: z.string().min(1).optional(),
    label: z.string().min(1),
    enabled: z.boolean(),
    criteria: PurchaseQuickViewCriteriaSchema,
  });

export const GetStationPurchaseQuickViewsRequestSchema: z.ZodType<GetStationPurchaseQuickViewsRequest> =
  z.object({
    companyId: z.uuid(),
    storeId: z.uuid(),
    locationId: z.uuid(),
    stationId: z.uuid(),
  });

export const GetStationPurchaseQuickViewsResponseSchema: z.ZodType<GetStationPurchaseQuickViewsResponse> =
  z.object({
    quickViews: z.array(PurchaseStationQuickViewSchema),
  });

export const ReplaceStationPurchaseQuickViewsRequestSchema: z.ZodType<ReplaceStationPurchaseQuickViewsRequest> =
  z.object({
    companyId: z.uuid(),
    storeId: z.uuid(),
    locationId: z.uuid(),
    stationId: z.uuid(),
    quickViews: z.array(PurchaseStationQuickViewInputSchema),
  });

export const ReplaceStationPurchaseQuickViewsResponseSchema: z.ZodType<ReplaceStationPurchaseQuickViewsResponse> =
  z.object({
    quickViews: z.array(PurchaseStationQuickViewSchema),
  });
